import { useMutation } from '@tanstack/react-query';

import { api } from 'services/api';

const submitFax = async ({ formId, testFaxNumber }: any) => {
  const config = testFaxNumber ? { params: { testFaxNumber } } : null;

  const faxRes = await api.post(
    `/forms/${formId}/fax/submit`,
    null,
    config as any,
  );

  return faxRes?.data.data;
};

export const useMutateSubmitFax = ({ formId }: any) => {
  return useMutation({
    mutationKey: ['submitFax', formId],
    mutationFn: submitFax,
  });
};
